<script>
export default {
  name: 'ValueComboBox',
  props: {
    items: { type: Array },
    enabledItems: { type: Array, required: false, default: null },
    disabledItems: { type: Array, required: false, default: null },
    multiple: { type: Boolean, required: false, default: false },
    value: { required: true }
  },
  computed: {
    hasSelectionSlot() {
      return !!this.$slots.selection && !!this.$slots.selection[0]
    },
    activeValue() {
      if (this.multiple) {
        const values = this.value || []
        return values.map(_value =>
          this.items.find(item => (typeof item === 'object' ? item.value === _value : item === _value))
        )
      } else {
        return this.items.find(item => (typeof item === 'object' ? item.value === this.value : item === this.value))
      }
    },
    activeItems() {
      let items = [...this.items]
      if (!this.enabledItems && !this.disabledItems) {
        return this.items
      } else if (this.enabledItems && !this.disabledItems) {
        return items.filter(item => this.enabledItems.includes(typeof item === 'object' ? item.value : item))
      } else if (!this.enabledItems && this.disabledItems) {
        return items.filter(item => !this.disabledItems.includes(typeof item === 'object' ? item.value : item))
      } else {
        return items.filter(
          item =>
            !this.disabledItems.includes(typeof item === 'object' ? item.value : item) ||
            this.enabledItems.includes(typeof item === 'object' ? item.value : item)
        )
      }
    }
  },
  methods: {
    onInput(value) {
      if (this.multiple) {
        this.$emit(
          'input',
          value.map(_value => (typeof _value === 'object' && _value !== null ? _value.value : _value))
        )
      } else {
        this.$emit('input', typeof value === 'object' && value !== null ? value.value : value)
      }
    }
  },
  inheritAttrs: false
}
</script>

<template>
  <v-combobox :value="activeValue" :items="activeItems" :multiple="multiple" @input="onInput" v-bind="$attrs">
    <template v-if="hasSelectionSlot" v-slot:selection="props">
      <slot name="selection" v-bind="props" />
    </template>
  </v-combobox>
</template>
